import { render, staticRenderFns } from "./ModalError.vue?vue&type=template&id=1e33e524&"
import script from "./ModalError.vue?vue&type=script&lang=js&"
export * from "./ModalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports